export const HUBSPOT_SOFTWARE_INDEX = 'HUBSPOT_SOFTWARE';